import React, { FunctionComponent, useCallback, useMemo } from 'react';

import cn from 'classnames';
import { connect, ConnectedProps } from 'react-redux';

import { RootState } from '../../../../../../init-store';
import { getConferenceStatus } from '../../../../../pages/call/selectors';
import { Button } from '../../../../components';
import { i18n } from '../../../../helpers/i18n';
import { countMetrika } from '../../../../helpers/metrika';
import { toPassport } from '../../../user';
import { isB2bUserSelector } from '../../../user/selectors';
import css from './account.css';

const mapStateToProps = (state: RootState) => {
    return {
        user: state.user,
        idUrl: state.config.yaServices.id,
        isJoined: getConferenceStatus(state) === 'joined',
        isB2bUser: isB2bUserSelector(state),
    };
};

const mapDispatchToProps = {
    toPassport,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type AccountSectionProps = ConnectedProps<typeof connector>;

const AccountSection: FunctionComponent<AccountSectionProps> = ({ user, toPassport, idUrl, isJoined, isB2bUser }) => {
    const avatarBgStyle = useMemo(() => ({ backgroundImage: `url(${user?.avatarUrl})` }), [user?.avatarUrl]);
    const retPath = encodeURIComponent(window.location.href);

    const authedUser = useCallback(() => {
        return (
            <>
                <div className={css.UserBlock}>
                    <div className={css.UserAvatar} style={avatarBgStyle} />
                    <div className={css.UserInfo}>
                        <div className={css.UserName}>{user?.displayName}</div>
                        <div className={css.UserLogin}>{user?.login}</div>
                    </div>
                </div>

                <Button
                    className={cn(css.ChangeAvatarButton, 'СhangeAvatarButton')}
                    view="neutral"
                    size="md"
                    elementType="a"
                    href={
                        isJoined
                            ? `${idUrl}/personal?dialog=personal-data&origin=b2b360&retpath=${idUrl}`
                            : `${idUrl}/personal?dialog=personal-data&origin=b2b360&retpath=${retPath}`
                    }
                    target={isJoined ? '_blank' : '_self'}
                    onClick={() => {
                        countMetrika(isJoined ? 'meeting_screen' : 'main_screen', 'settings', 'change_name_avatar');
                    }}
                >
                    {i18n('settings', isB2bUser ? 'change-avatar' : 'change-name-and-avatar')}
                </Button>
            </>
        );
    }, [avatarBgStyle, user?.displayName, user?.login, idUrl, isB2bUser, isJoined, retPath]);

    const handleLoginClick = useCallback(() => toPassport(), [toPassport]);

    const notAuthedUser = useCallback(() => {
        return (
            <Button view="brand" size="md" onClick={handleLoginClick}>
                {i18n('settings', 'login')}
            </Button>
        );
    }, [handleLoginClick]);

    return <div className={css.Container}>{user ? authedUser() : notAuthedUser()}</div>;
};

export default connector(AccountSection);
